var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlbum(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "50.000000pt",
    height: "50.000000pt",
    viewBox: "0 0 50.000000 50.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,50.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107 454 c-11 -11 -8 -44 3 -44 6 0 10 7 10 15 0 13 21 15 130 15 109 0 130 -2 130 -15 0 -8 5 -15 11 -15 6 0 9 10 7 23 -3 21 -6 22 -144 25 -77 1 -143 -1 -147 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77 384 c-11 -11 -8 -44 3 -44 6 0 10 7 10 15 0 13 24 15 160 15 136 0 160 -2 160 -15 0 -8 5 -15 11 -15 6 0 9 10 7 23 -3 22 -5 22 -174 25 -93 1 -173 -1 -177 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 307 c-2 -7 -3 -69 -2 -138 l3 -124 205 0 205 0 0 135 0 135 -203 3 c-161 2 -204 0 -208 -11z m396 -127 l0 -120 -190 0 -190 0 0 120 0 120 190 0 190 0 0 -120z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlbum);
export default __webpack_public_path__ + "static/media/album.690a14c9e0979ef02a9b868d41d5a98b.svg";
export { ForwardRef as ReactComponent };